export default function initWordsFlip() {
  const isPresent = document.querySelector("[data-shuffle]");
  if (!isPresent) {
    return;
  }

  const words = document.querySelector("[data-shuffle]").dataset.shuffle;
  const word = words.split(", ");
  const element = document.querySelector("[data-shuffle] span");

  let wordIndex = 1;

  let resetAnimation = function () {
    element.classList.remove("flip");
  };

  setInterval(function () {
    wordIndex++;
    if (wordIndex > word.length - 1) {
      wordIndex = 0;
    }

    element.classList.add("flip");
    element.textContent = word[wordIndex];
    setTimeout(resetAnimation, 1000);
  }, 2000);
}
